import { render, staticRenderFns } from "./ModalCart.vue?vue&type=template&id=66e71144&"
import script from "./ModalCart.vue?vue&type=script&lang=js&"
export * from "./ModalCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports